import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from 'primereact/button';
import { API, DataStore, graphqlOperation } from 'aws-amplify';
import * as mutations from "../../graphql/mutations";
import * as queries from "../../graphql/queries";
import { toast } from "react-toastify";
import { graphQLFindRecordById } from "../../helper/commonfunctions";
import { StipendMaster } from "../../models";

const RestoreDialog = (props) => {


  console.log("props", props);

  // const {data} = props;

  const handleDeleteRow = async restoreData => {

    try {

      console.log("restoreData", restoreData);
      if (props.tableName == "getStipendMaster22") {
        const original = await DataStore.query(StipendMaster, restoreData.Id);
// console.log('✌️original --->', original);
        await DataStore.save(
          StipendMaster.copyOf(original, (updated) => {
            updated.isArchived = true;
          })
        )
      } else {
        let original = await graphQLFindRecordById(props.tableName, restoreData.id)
		
		console.log(original,"original")
		
		let arrayOfObjects=JSON.parse(original?.isArchivedUsers);
		
		console.log(arrayOfObjects,"arrayOfObjects")
		// Define the condition for deletion
		let userIdToDelete = props.loggedUserId;
		let archiveDesignationToDelete = restoreData.archiveDesignation;

		// Use the filter method to create a new array without the matched objects
		let newArray = arrayOfObjects.filter(obj => !(obj.userId === userIdToDelete && obj.archiveDesignation === archiveDesignationToDelete));
		console.log(newArray,"newArray")
		newArray = JSON.stringify(newArray)

    

        await API.graphql(
          graphqlOperation(props.mutations, {
            input: {
              id: original.id,
              isArchivedUsers: newArray,
              isArchived: false,
              _version: original?._version
            }
          })
        );
      }
      toast.success('Request Restored Successfully.');
      props.setIsLoadData();
      props.getMasterData();

    } catch (err) {
      console.log("Error is Delete :-", err);
    }
  };




  const footerContentForDeleteForm = () => (
    <div className="text-center">
      <>
        <button
          className="inline-flex justify-center py-[12px] xl:py-[0.625vw] px-[16px] xl:px-[0.833vw] text-white text-[14px] xl:text-[0.729vw] font-medium bg-[#113699] border border-[#EFF8FF] rounded-md"
          onClick={() => {
            handleDeleteRow(props.restoreData);
            props.setIsVisibleDelete(false);
          }}
        >
          OK
        </button>
        <button
          onClick={() => {
            props.setIsVisibleDelete(false);
          }}
          type="button"
          className="inline-flex justify-center py-[12px] xl:py-[0.625vw] px-[16px] xl:px-[0.833vw] text-[#2D5BE5] text-[14px] xl:text-[0.729vw] font-medium bg-[#EFF8FF] border border-[#EFF8FF] rounded-md"
          id="add-family-cancel-btn"
        >
          Cancel
        </button>

      </>
    </div>
  );



  return (
    <>
      <Dialog
        header=""
        visible={props.isVisibleDelete}
        style={{ width: "30vw" }}
        //                      closable={false}
        onHide={() => {
          props.setIsVisibleDelete(false);
        }}
        footer={footerContentForDeleteForm}
      >
        <div className="m-0">
          <div className="font-medium text-[18px] text-[#249144]">
            Are you sure you want to restore the record?
          </div>
        </div>
      </Dialog>
    </>
  )

}

export default RestoreDialog
